import observationRangeValidation from '@shared/clinical-logic/helpers/observationRangeValidation'

const { validateBloodPressure, validateObservationValue } = observationRangeValidation

const WARNING_MESSAGE_TOKEN = 'questions.generic.message.abnormal'
const BLOCKING_MESSAGE_TOKEN = 'questions.blood_pressure.message.error'
const SCALAR_RANGE_PANELS = [
  'heart_rate',
  'respiratory_rate',
  'oxygen_saturation',
  'temperature',
  'weight',
  'height',
]

function withMessageToken(result) {
  let messageToken = null
  if (result.severity === 'warning') messageToken = WARNING_MESSAGE_TOKEN
  if (result.severity === 'blocking') messageToken = BLOCKING_MESSAGE_TOKEN
  return { ...result, messageToken }
}

export default {
  methods: {
    emitRangeValidation(result, showMessage = true) {
      const validation = withMessageToken(result)
      if (showMessage) this.$emit('warningEvent', validation)
      return validation
    },
    usesScalarRangeValidation() {
      return SCALAR_RANGE_PANELS.includes(this.panelName)
    },
    validateObservationRange(value, range = this.options, showMessage = true) {
      if (!this.usesScalarRangeValidation()) {
        return this.emitRangeValidation({ severity: 'normal', code: 'normal', value }, showMessage)
      }
      return this.emitRangeValidation(validateObservationValue(range, value), showMessage)
    },
    validateBloodPressureRange(value, range = this.options, showMessage = true) {
      if (this.panelName !== 'blood_pressure') {
        return this.emitRangeValidation({ severity: 'normal', code: 'normal', value }, showMessage)
      }
      return this.emitRangeValidation(validateBloodPressure(range, value), showMessage)
    },
    clearRangeValidation(value = null) {
      return this.emitRangeValidation({ severity: 'normal', code: 'normal', value })
    },
    BPMoutOfRange(bpm, showMessage = true) {
      if (!Number.isFinite(Number(bpm)) || Number(bpm) <= 0) return false
      const validation = this.validateObservationRange(bpm, this.options, showMessage)
      return validation.severity === 'warning' || validation.severity === 'blocking'
    }
  }
}
